let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3zuUe")).then(() => parcelRequire('h0sHG'));